import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import innovationImg from '../../assets/images/hero/innovation.svg'

function Home() {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="page home-page">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-100 py-12 sm:py-20 relative overflow-hidden">
        {/* Decorative background elements */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-100/20 to-indigo-100/20"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmOGZhZmMiIGZpbGwtb3BhY2l0eT0iMC4xIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSI0Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-30"></div>
        <div className="container mx-auto px-3 sm:px-4 text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight px-2">
            Transforme sua <span className="text-[#2F5496]">Visão</span> em <span className="text-[#2F5496]">Realidade Digital</span>
          </h1>
          
          {/* PRATA Acronym Block */}
          <div className="mb-8 px-2">
            <div className="inline-block bg-white/90 backdrop-blur-sm rounded-2xl px-3 sm:px-6 md:px-8 py-3 sm:py-4 shadow-lg border border-blue-100 max-w-full">
              <div className="text-sm sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-800 break-words">
                <span className="text-[#2F5496]">P</span>recisão <span className="text-[#2F5496]">R</span>acional <span className="text-[#2F5496]">A</span>plicada à <span className="text-[#2F5496]">T</span>ecnologia <span className="text-[#2F5496]">A</span>vançada
              </div>
            </div>
          </div>
          
          <p className="text-lg sm:text-xl md:text-2xl text-gray-700 mb-6 max-w-3xl mx-auto leading-relaxed px-2">
            Na Prata Consultoria, criamos soluções tecnológicas inovadoras que impulsionam o crescimento do seu negócio e superam suas expectativas.
          </p>
          <p className="text-base sm:text-lg text-gray-600 mb-8 max-w-4xl mx-auto leading-relaxed px-2">
            Somos especialistas em transformar ideias complexas em sistemas digitais elegantes e funcionais. Nossa abordagem combina criatividade, 
            inovação técnica e profundo entendimento das necessidades do mercado, garantindo que cada projeto não apenas atenda às expectativas, 
            mas as supere de forma extraordinária.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center px-2">
            <Link to="/quote" className="btn-primary text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 transform hover:scale-105 hover:shadow-xl transition-all duration-300 animate-pulse hover:animate-none text-center">
              Solicitar Orçamento
            </Link>
            <Link to="/services" className="btn-secondary text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 transform hover:scale-105 hover:shadow-lg transition-all duration-300 hover:bg-blue-50 text-center">
              Conhecer Nossos Serviços
            </Link>
          </div>
        </div>
        
        {/* Additional floating elements */}
        <div className="absolute top-20 left-20 w-4 h-4 bg-blue-400 rounded-full opacity-60 animate-bounce hidden sm:block"></div>
        <div className="absolute bottom-20 right-20 w-6 h-6 bg-indigo-400 rounded-full opacity-50 animate-pulse hidden sm:block"></div>
        <div className="absolute top-1/2 left-10 w-3 h-3 bg-blue-300 rounded-full opacity-70 animate-ping hidden sm:block"></div>
      </div>


      {/* Services Section */}
      <div className="container mx-auto px-3 sm:px-4 py-20">
        <div className="text-center mb-16 px-2">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            Soluções Completas em Tecnologia
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Oferecemos um ecossistema completo de serviços tecnológicos, desde o planejamento estratégico até a implementação e suporte contínuo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:rotate-12 transition-transform duration-300">
              <svg className="w-8 h-8 text-blue-600 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900 group-hover:text-blue-600 transition-colors duration-300 break-words px-1">Desenvolvimento Personalizado</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Criamos aplicações web e mobile sob medida, utilizando as mais modernas tecnologias e metodologias ágeis para garantir qualidade e eficiência.
            </p>
            <div className="mt-4 w-12 h-1 bg-gradient-to-r from-blue-400 to-blue-600 mx-auto rounded-full group-hover:w-20 transition-all duration-300"></div>
          </div>

          <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:rotate-12 transition-transform duration-300">
              <svg className="w-8 h-8 text-green-600 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900 group-hover:text-green-600 transition-colors duration-300 break-words px-1">Consultoria Estratégica</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Nossos especialistas analisam sua infraestrutura atual e desenvolvem estratégias tecnológicas que otimizam processos e maximizam resultados.
            </p>
            <div className="mt-4 w-12 h-1 bg-gradient-to-r from-green-400 to-green-600 mx-auto rounded-full group-hover:w-20 transition-all duration-300"></div>
          </div>

          <div className="card text-center group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-purple-200 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:rotate-12 transition-transform duration-300">
              <svg className="w-8 h-8 text-purple-600 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z" />
              </svg>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900 group-hover:text-purple-600 transition-colors duration-300 break-words px-1">Suporte 24/7</h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Oferecemos suporte técnico especializado e manutenção preventiva para garantir que seus sistemas operem com máxima performance e disponibilidade.
            </p>
            <div className="mt-4 w-12 h-1 bg-gradient-to-r from-purple-400 to-purple-600 mx-auto rounded-full group-hover:w-20 transition-all duration-300"></div>
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="bg-gray-50 py-20">
        <div className="container mx-auto px-3 sm:px-4">
          <div className="text-center mb-16 px-2">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
              Por que Escolher a Prata Consultoria?
            </h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
              Somos mais que uma empresa de tecnologia. Somos seus parceiros estratégicos na jornada da transformação digital.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            <div className="text-center group transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl font-bold text-[#2F5496] mb-2 group-hover:text-[#1e40af] transition-colors">2022</div>
              <div className="text-lg font-semibold text-gray-900 mb-2">Inovação Constante</div>
              <div className="text-gray-600">Desde nossa fundação</div>
            </div>
            <div className="text-center group transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl font-bold text-[#2F5496] mb-2 group-hover:text-[#1e40af] transition-colors">∞</div>
              <div className="text-lg font-semibold text-gray-900 mb-2">Potencial Ilimitado</div>
              <div className="text-gray-600">Para transformar ideias</div>
            </div>
            <div className="text-center group transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl font-bold text-[#2F5496] mb-2 group-hover:text-[#1e40af] transition-colors">100%</div>
              <div className="text-lg font-semibold text-gray-900 mb-2">Compromisso Total</div>
              <div className="text-gray-600">Com cada projeto</div>
            </div>
            <div className="text-center group transform hover:scale-105 transition-all duration-300">
              <div className="text-4xl font-bold text-[#2F5496] mb-2 group-hover:text-[#1e40af] transition-colors">24/7</div>
              <div className="text-lg font-semibold text-gray-900 mb-2">Suporte Disponível</div>
              <div className="text-gray-600">Para nossos clientes</div>
            </div>
          </div>

          {/* Innovation showcase */}
          <div className="bg-gradient-to-br from-white to-blue-50 rounded-2xl p-8 shadow-xl border border-blue-100 transform hover:scale-[1.02] transition-all duration-500">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4 transform hover:scale-105 transition-transform duration-300">
                  Tecnologias Emergentes
                </h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Estamos sempre na vanguarda da tecnologia, explorando e implementando as mais recentes inovações para manter nossos clientes à frente da concorrência.
                </p>
                <ul className="space-y-4">
                  <li className="flex items-center group transform hover:translate-x-2 transition-all duration-300">
                    <span className="w-3 h-3 bg-gradient-to-r from-[#2F5496] to-[#1e40af] rounded-full mr-4 animate-pulse"></span>
                    <span className="group-hover:text-[#2F5496] transition-colors duration-300">Inteligência Artificial e Machine Learning</span>
                  </li>
                  <li className="flex items-center group transform hover:translate-x-2 transition-all duration-300">
                    <span className="w-3 h-3 bg-gradient-to-r from-green-500 to-green-600 rounded-full mr-4 animate-pulse"></span>
                    <span className="group-hover:text-green-600 transition-colors duration-300">Computação em Nuvem e DevOps</span>
                  </li>
                  <li className="flex items-center group transform hover:translate-x-2 transition-all duration-300">
                    <span className="w-3 h-3 bg-gradient-to-r from-purple-500 to-purple-600 rounded-full mr-4 animate-pulse"></span>
                    <span className="group-hover:text-purple-600 transition-colors duration-300">Blockchain e Tecnologias Distribuídas</span>
                  </li>
                  <li className="flex items-center group transform hover:translate-x-2 transition-all duration-300">
                    <span className="w-3 h-3 bg-gradient-to-r from-orange-500 to-orange-600 rounded-full mr-4 animate-pulse"></span>
                    <span className="group-hover:text-orange-600 transition-colors duration-300">Internet das Coisas (IoT)</span>
                  </li>
                </ul>
              </div>
              <div className="text-center transform hover:rotate-3 transition-transform duration-500">
                <img src={innovationImg} alt="Tecnologias Emergentes" className="w-full h-auto max-w-md mx-auto drop-shadow-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-br from-[#2F5496] via-[#1e40af] to-[#1e3a8a] py-16 sm:py-20 relative overflow-hidden">
        <div className="container mx-auto px-3 sm:px-4 text-center relative z-10">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6 transform hover:scale-105 transition-transform duration-300 px-2">
            Pronto para Transformar seu Negócio?
          </h2>
          <p className="text-lg sm:text-xl text-blue-100 mb-8 max-w-2xl mx-auto leading-relaxed px-2">
            Entre em contato conosco hoje mesmo e descubra como podemos acelerar o crescimento da sua empresa com soluções tecnológicas inovadoras.
          </p>
          <Link to="/contact" className="inline-block bg-white text-[#2F5496] font-bold text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 hover:shadow-xl animate-bounce hover:animate-none mx-2">
            Fale Conosco Agora
          </Link>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute top-10 left-10 w-20 h-20 bg-white opacity-10 rounded-full animate-ping hidden sm:block"></div>
        <div className="absolute bottom-10 right-10 w-16 h-16 bg-white opacity-10 rounded-full animate-pulse hidden sm:block"></div>
        <div className="absolute top-1/2 left-1/4 w-8 h-8 bg-white opacity-5 rounded-full animate-bounce hidden sm:block"></div>
        <div className="absolute top-1/3 right-1/4 w-12 h-12 bg-white opacity-5 rounded-full animate-pulse hidden sm:block"></div>
      </div>
    </div>
  )
}

export default Home

